var BASWebServices;
(function (BASWebServices) {
    var TermsOfUsageController = (function () {
        function TermsOfUsageController($scope, $http, touService) {
            this.$scope = $scope;
            this.$http = $http;
            this.touService = touService;
            this.$scope.touc = this;
            var _scope = this.$scope;
            touService.getTOUContentAcademic().then(function (result) {
                _scope.touAcademic = result.data;
            });
            touService.getTOUContentCommercial().then(function (result) {
                _scope.touCommercial = result.data;
            });
            ;
        }
        return TermsOfUsageController;
    }());
    BASWebServices.TermsOfUsageController = TermsOfUsageController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=TermsOfUsageController.js.map